<template>
  <div 
    class="menu-item"
    :class="[`${type}-menu-item`, { active }]"
    @click="$emit('select', item)">
    <div class="menu-item-content">
      <div class="menu-icon">
        <i :class="iconClass"></i>
      </div>
      <span class="menu-text" :title="item.name">{{ item.name }}</span>
      <div class="menu-indicator" v-if="active && type === 'primary'">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="menu-actions">
      <el-button 
        type="text" 
        size="mini" 
        icon="el-icon-edit"
        title="编辑"
        @click.stop="$emit('edit', item)">
      </el-button>
      <el-button 
        type="text" 
        size="mini" 
        icon="el-icon-delete"
        title="删除"
        @click.stop="$emit('delete', item)">
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    item: Object,
    active: Boolean,
    type: String
  },
  computed: {
    iconClass() {
      if (this.type === 'primary') {
        return 'el-icon-office-building'
      }
      return 'el-icon-school'
    }
  }
}
</script>

<style scoped>
.menu-item {
  padding: 0;
  margin: 4px 8px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #ffffff;
  border: 1px solid transparent;
  overflow: hidden;
  min-height: 48px;
}

.menu-item-content {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  flex: 1;
  gap: 12px;
  min-width: 0;
  overflow: hidden;
}

.menu-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.menu-icon i {
  font-size: 14px;
  color: #6c757d;
  transition: all 0.3s ease;
}

.menu-text {
  flex: 1;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  transition: all 0.3s ease;
  min-width: 0;
  max-width: 140px;
}

.menu-indicator {
  margin-left: auto;
  color: #00d8c3;
  font-weight: bold;
  animation: pulse 2s infinite;
}

.menu-actions {
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  gap: 4px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 6px;
  backdrop-filter: blur(4px);
}

.menu-item:hover .menu-actions {
  opacity: 1;
}

.menu-item:hover {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.menu-item:hover .menu-text {
  color: #00d8c3;
}

.menu-item:hover .menu-icon {
  background: linear-gradient(135deg, #00d8c3 0%, #00d8c3 100%);
}

.menu-item:hover .menu-icon i {
  color: white;
}

.menu-item.active {
  background: linear-gradient(135deg, #e8f5f7 0%, #d1ecf1 100%);
  border: 1px solid #00d8c3;
}

.menu-item.active .menu-text {
  color: #00d8c3;
  font-weight: bold;
}

.menu-item.active .menu-icon {
  background: linear-gradient(135deg, #00d8c3 0%, #00b8a9 100%);
  box-shadow: 0 2px 8px rgba(0, 216, 195, 0.4);
  transform: scale(1.1);
}

.menu-item.active .menu-icon i {
  color: white;
  font-weight: bold;
}

.primary-menu-item .menu-icon {
  background: linear-gradient(135deg, #139BA5 0%, #0f7a82 100%);
}

.primary-menu-item .menu-icon i {
  color: white;
}

.primary-menu-item.active .menu-icon {
  background: linear-gradient(135deg, #00d8c3 0%, #00b8a9 100%);
  box-shadow: 0 2px 8px rgba(0, 216, 195, 0.4);
  transform: scale(1.1);
}

.secondary-menu-item .menu-icon {
  background: linear-gradient(135deg, #139BA5 0%, #0f7a82 100%);
}

.secondary-menu-item .menu-icon i {
  color: white;
}

.secondary-menu-item.active .menu-icon {
  background: linear-gradient(135deg, #00d8c3 0%, #00b8a9 100%);
  box-shadow: 0 2px 8px rgba(0, 216, 195, 0.4);
  transform: scale(1.1);
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}
</style>